export const sortedVal = items => {
  const stock = []
  const outOfStock = []
  const discontinued = []
  items.forEach(v => {
    if (v?.discontinued === true) {
      discontinued.push(v)
    } else if (v?.isStock === "true") {
      stock.push(v)
    } else {
      outOfStock.push(v)
    }
  })
  const data = [...stock, ...outOfStock, ...discontinued]
  return data.length === items.length ? data : items
}
